/**
 * Spacing-related semantic tokens for PrimeNG preset
 * Includes layout, spacing, and radius tokens
 */

import * as p from '../tokens/primitives.js';
import { layout as semanticLayout } from '../tokens/semantic.js';

export const spacing = {
  // Border & Radius (using p.borderRadius directly from Figma primitives)
  border: {
    radius: {
      none: '0',
      xs: p.borderRadius[4],   // 4px
      sm: p.borderRadius[4],   // 4px
      md: p.borderRadius[8],   // 8px
      lg: p.borderRadius[16],  // 16px
      xl: p.borderRadius[24],  // 24px
    },
  },

  // Layout tokens (from semantic.ts, synced with Figma)
  layout: {
    gap: semanticLayout.gap,
    padding: semanticLayout.padding,
  },

  // Spacing tokens (aligned with layout.padding from Figma)
  spacing: {
    xs: p.spacing[8],   // 0.5rem (8px)
    sm: p.spacing[24],  // 1.5rem (24px)
    md: p.spacing[48],  // 3rem (48px)
    lg: p.spacing[56],  // 3.5rem (56px)
    xl: p.spacing[64],  // 4rem (64px)
  },

  // Radius tokens (for top-level access)
  radius: {
    none: '0',
    xs: p.borderRadius[4],   // 4px
    sm: p.borderRadius[4],   // 4px
    md: p.borderRadius[8],   // 8px
    lg: p.borderRadius[16],  // 16px
    xl: p.borderRadius[24],  // 24px
  },
};
